import React from 'react';
import { connect } from 'react-redux';
import { Field, getFormValues } from 'redux-form';

import SettingField from 'components/Fields/ReduxForm/SettingField';

const InputSalesType = props => {
  const { index, input, indexSalesType } = props;
  return (
    <div>
      <div className="mk-grouped-input">
        <div className={`form-group col-md-4`}>
          <Field
            name={`item_variants[${index}].name`}
            component={SettingField}
            className="form-control"
            placeholder="Name"
            dis
          />
        </div>
        <div className={'form-group col-md-4 no-padding'}>
          <Field
            name={`${input.name}[${indexSalesType}].price`}
            component={SettingField}
            maxLength={11}
            placeholder="Price"
            inputClassName="text-right"
            positiveNumberOnly
          />
        </div>
        <div className="item-variant-sales-type-input-sku form-group col-md-4">
          <Field
            name={`item_variants[${index}].sku`}
            component="input"
            className="form-control text-align-last-left"
            placeholder="SKU"
            disabled
          />
        </div>
      </div>
    </div>
  );
};

class SalesTypeItemVariantsList extends React.Component {
  render() {
    const { index, itemForm, name } = this.props;
    return (
      <div>
        {itemForm.item_variants.map((item, idx) => {
          return (
            <Field
              name={`${name}[${idx}].sales_type_item_variants`}
              component={InputSalesType}
              index={idx}
              indexSalesType={index}
            />
          );
        })}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    itemForm: getFormValues('itemHub')(state),
  };
}

export default connect(mapStateToProps)(SalesTypeItemVariantsList);
